import { UiToaster } from "@bi-book/bibook-ui-kit";

export default {
  install: (app) => {
    app.config.globalProperties.$toaster = UiToaster;
  },
};
